import { render, staticRenderFns } from "./bmShouldKnow.vue?vue&type=template&id=754c6f87&scoped=true"
import script from "./bmShouldKnow.vue?vue&type=script&lang=js"
export * from "./bmShouldKnow.vue?vue&type=script&lang=js"
import style0 from "./bmShouldKnow.vue?vue&type=style&index=0&id=754c6f87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c6f87",
  null
  
)

export default component.exports